import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PartBaseComponent } from '../_components/part-base/part-base.component';

const routes: Routes = [
  { path: '', component: PartBaseComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PartRouteModule { }
